module.exports = __webpack_public_path__ + "img/流体力学3_5_2.b29353e3.jpg";